import { render } from "./PlaylistEdit.vue?vue&type=template&id=540c7078"
import script from "./PlaylistEdit.vue?vue&type=script&lang=js"
export * from "./PlaylistEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/PlaylistEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "540c7078"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('540c7078', __exports__)) {
    api.reload('540c7078', __exports__)
  }
  
  module.hot.accept("./PlaylistEdit.vue?vue&type=template&id=540c7078", () => {
    api.rerender('540c7078', render)
  })

}


export default __exports__